import { expVal } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

let disableRelayOverride: boolean | undefined;

function isRelayDisabledByQueryParam(): boolean {
	if (disableRelayOverride !== undefined) {
		return disableRelayOverride;
	}

	try {
		if (typeof window !== 'undefined' && window.location?.search) {
			const params = new URLSearchParams(window.location.search);
			const value = params.get('disableRelay');
			disableRelayOverride = value === '1' || value === 'true';
		} else {
			disableRelayOverride = false;
		}
	} catch {
		disableRelayOverride = false;
	}

	return disableRelayOverride;
}

export function isRelayEnabled(callerPackage?: string): boolean {
	// Query param override: ?disableRelay=1 or ?disableRelay=true forces Relay off
	if (isRelayDisabledByQueryParam()) return false;

	if (process.env.BUILD_VARIANT === 'relay') return true;

	if (!callerPackage) {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR) {
			// eslint-disable-next-line no-console
			console.warn(
				'[Relay migration] isRelayEnabled called without callerPackage; returning false.',
			);
		}
		return false;
	}

	if (!expVal('confluence_apollo_to_relay_migration', 'isEnabled', false)) {
		return false;
	}

	const packages = StatsigConfigurations.getStringList('confluence_relay_enabled_packages', []);
	const relayEnabled = packages.includes(callerPackage);
	return relayEnabled;
}
